<div>
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>

<div id="loader">
  <img src="../assets/loader.gif" />
</div>